var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"barcode",staticClass:"code-preview__img",attrs:{"id":"barcode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }